import {
  ScmAuth,
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
} from '@backstage/integration-react';
import {
  AnyApiFactory,
  identityApiRef,
  configApiRef,
  createApiFactory,
  storageApiRef,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { VisitsStorageApi, visitsApiRef } from '@backstage/plugin-home';
import { BackstageInsights } from '@spotify/backstage-plugin-analytics-module-insights';
import {
  aiRulesApiRef,
  AiRulesClient,
} from '@terasky/backstage-plugin-ai-rules';
import {
  lighthouseTagsApiRef,
  LighthouseTagsClient,
  LighthouseApiWithTags,
} from '@zeiss/plugin-zeiss-lighthouse';
import { lighthouseApiRef } from '@backstage-community/plugin-lighthouse';
import { LighthouseRestApi } from '@backstage-community/plugin-lighthouse-common';

export const apis: AnyApiFactory[] = [
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),
  ScmAuth.createDefaultApiFactory(),
  createApiFactory({
    api: visitsApiRef,
    deps: {
      storageApi: storageApiRef,
      identityApi: identityApiRef,
    },
    factory: ({ storageApi, identityApi }) =>
      VisitsStorageApi.create({ storageApi, identityApi }),
  }),
  BackstageInsights.createDefaultApiFactory(),
  createApiFactory({
    api: aiRulesApiRef,
    deps: { discoveryApi: discoveryApiRef, identityApi: identityApiRef },
    factory: ({ discoveryApi, identityApi }) =>
      new AiRulesClient({ discoveryApi, identityApi }),
  }),
  createApiFactory({
    api: lighthouseTagsApiRef,
    deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
    factory: ({ discoveryApi, fetchApi }) =>
      new LighthouseTagsClient({ discoveryApi, fetchApi }),
  }),
  createApiFactory({
    api: lighthouseApiRef,
    deps: {
      configApi: configApiRef,
      identityApi: identityApiRef,
      discoveryApi: discoveryApiRef,
      fetchApi: fetchApiRef,
    },
    factory: ({ configApi, identityApi, discoveryApi, fetchApi }) =>
      new LighthouseApiWithTags({
        inner: LighthouseRestApi.fromConfig(configApi),
        tagsApi: new LighthouseTagsClient({ discoveryApi, fetchApi }),
        identityApi,
      }),
  }),
];
